import loadable from '@loadable/component';

export const DecanterSiteWrapper = loadable(
  () => import(/* webpackChunkName: "decanter-site" */ './DecanterSiteWrapper'),
);
